const loadFlightTrafficPrefix = 'loadFlightTraffics';
export const loadFlightTrafficActionTypes = {
    LOAD: `${loadFlightTrafficPrefix}/LOAD_FLIGHT_TRAFFIC`,
    LOADING: `${loadFlightTrafficPrefix}/LOADING_FLIGHT_TRAFFIC`,
    LOADED: `${loadFlightTrafficPrefix}/LOADED_FLIGHT_TRAFFIC`,
};
export const loadFlightTraffic = (flightId, workspaceId, managementGroup) => {
    return {
        type: loadFlightTrafficActionTypes.LOAD,
        payload: {
            flightId: flightId,
            workspaceId: workspaceId,
            managementGroup: managementGroup,
        },
    };
};
export const loadingFlightTraffic = (flightId, workspaceId, managementGroup) => {
    return {
        type: loadFlightTrafficActionTypes.LOADING,
        payload: {
            flightId,
            workspaceId,
            managementGroup,
        },
    };
};
export const loadedFlightTraffic = (flightId, workspaceId, managementGroup, data, error) => {
    return {
        type: loadFlightTrafficActionTypes.LOADED,
        payload: {
            flightId,
            workspaceId,
            managementGroup,
            data,
            error,
        },
    };
};

//# sourceMappingURL=FlightTraffic.ducks.js.map
